import React from "react";
import {
  Row,
  Col,
  Input,
  Form,
  Button,
  Radio,
  Select,
  Upload,
  Icon,
  Spin,
  Tooltip
} from "antd";
import ReactTags from "react-tag-autocomplete";
import { strings, getConsultant } from "../../../helpers";
import NumericInput from "../../NumericInput";

const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const { Option } = Select;

class DoctorInfoView extends React.Component {
  /**
   * @func  handleSubmit
   * @description this will handle form when clicked on save button
   */
  handleSubmit = e => {
    if (e) e.preventDefault();
    const { selectedOtherSpecialities } = this.props;
    this.props.form.validateFieldsAndScroll((err, doctor) => {
      if (!err) {
        let otherSpecialities = [];
        let finalOtherSpecArray = [];
        if (selectedOtherSpecialities.length > 0) {
          otherSpecialities = JSON.parse(
            JSON.stringify(selectedOtherSpecialities)
          );
          otherSpecialities.map(obj => {
            finalOtherSpecArray.push(obj.name);
          });
        }

        const docObj = {
          doctor_details: {
            ...doctor,
            other_specialities: finalOtherSpecArray
          }
        };
        this.props.updateDoctorInfo(docObj);
      }
    });
    return false;
  };

  /**
   * @func getUploadLabel
   * @description this will show upload label
   */
  getUploadLabel = (photo, showCertificate) => {
    const { doctorsDetail } = this.props;
    if (photo) {
      return (
        <span>
          <a className="link-show-img" href="#" onClick={showCertificate}>
            {"View Certificate"}
          </a>{" "}
          {doctorsDetail && doctorsDetail.doctor.verified ? (
            ""
          ) : (
            <Tooltip title={"Delete Attachment"}>
              <a
                href="#"
                className="pl-25"
                onClick={this.props.toggleDeleteCertificateModal}
              >
                <Icon type="delete" />
              </a>
            </Tooltip>
          )}{" "}
        </span>
      );
    } else {
      return "Upload certificate";
    }
  };

  render() {
    const {
      doctorsDetail,
      updateProcessing,
      specialities,
      animateDocInfo,
      handleSpecilitySearch,
      handlePreview,
      handleChange,
      customRequest,
      uploading,
      regPhotoUrl,
      showCertificate,
      selectedOtherSpecialities,
      handleSpecSelect,
      handleSpecSearch,
      handleTagDelete
    } = this.props;
    const shwUploadCrt = true;
    const { getFieldDecorator } = this.props.form;
    return (
      <div
        className={`backgroundWhite mb-20 ${
          animateDocInfo ? "animate-form" : ""
        }`}
      >
        <div className="light-bg round-5x p-15 eq-column">
          <Form onSubmit={this.handleSubmit} layout="vertical">
            <Row type="flex" align="middle" gutter={16}>
              {shwUploadCrt ? (
                <Col sm={12} md={12} l={6} xl={6}>
                  <FormItem label={"Name"}>
                    {getFieldDecorator("name", {
                      initialValue: `${doctorsDetail.doctor.first_name} ${doctorsDetail.doctor.last_name}`,
                      rules: [
                        {
                          required: true,
                          message: `${"Enter name"}`
                        }
                      ]
                    })(<Input type="text" name="name" autoComplete="off" />)}
                  </FormItem>
                </Col>
              ) : (
                <Col span={8}>
                  <FormItem label={"Name"}>
                    {getFieldDecorator("name", {
                      initialValue: `${doctorsDetail.doctor.title}`,
                      rules: [
                        {
                          required: true,
                          message: `${"Enter Name"}`
                        }
                      ]
                    })(<Input type="text" name="name" autoComplete="off" />)}
                  </FormItem>
                </Col>
              )}
              {shwUploadCrt ? (
                <Col sm={12} md={12} l={6} xl={6}>
                  <FormItem label={"Speciality"}>
                    {getFieldDecorator("speciality", {
                      initialValue: doctorsDetail.doctor.speciality,
                      rules: [
                        {
                          required: true,
                          message: `${"Enter Speciality"}`
                        }
                      ]
                    })(
                      <Select showSearch onSearch={handleSpecilitySearch}>
                        {specialities.length &&
                          specialities.map(speciality => {
                            return (
                              <Option
                                key={speciality.id}
                                value={speciality.name}
                              >
                                {speciality.name}
                              </Option>
                            );
                          })}
                      </Select>
                    )}
                  </FormItem>
                </Col>
              ) : (
                <Col span={8}>
                  <FormItem label={"Speciality"}>
                    {getFieldDecorator("speciality", {
                      initialValue: doctorsDetail.doctor.speciality,
                      rules: [
                        {
                          required: true,
                          message: `${"Enter Speciality"}`
                        }
                      ]
                    })(
                      <Select showSearch onSearch={handleSpecilitySearch}>
                        {specialities.length &&
                          specialities.map(speciality => {
                            return (
                              <Option
                                key={speciality.id}
                                value={speciality.name}
                              >
                                {speciality.name}
                              </Option>
                            );
                          })}
                      </Select>
                    )}
                  </FormItem>
                </Col>
              )}

              <Col lg={10} md={13}>
                <FormItem label={"Gender"}>
                  {getFieldDecorator("gender", {
                    initialValue: doctorsDetail.doctor.gender
                  })(
                    <RadioGroup>
                      <Radio value="Male">{`${"Male"}`}</Radio>
                      <Radio value="Female">{`${"Female"}`}</Radio>
                      <Radio value={"Other"}>{`${"Other"}`}</Radio>
                    </RadioGroup>
                  )}
                </FormItem>
              </Col>
            </Row>

            <Row type="flex" gutter={20}>
              <Col lg={12} md={24} sm={24} xs={24}>
                <FormItem label="Other specialities">
                  <ReactTags
                    onDelete={handleTagDelete}
                    onAddition={handleSpecSelect}
                    tags={selectedOtherSpecialities}
                    suggestions={specialities}
                    placeholderText={"Type & select OR press enter to add"}
                    classNames={{
                      root: "react-tags",
                      search: "react-tags__search"
                    }}
                    onInput={handleSpecSearch}
                    allowNew
                    addOnBlur
                  />
                </FormItem>
              </Col>
            </Row>

            <Row type="flex" align="middle" gutter={16}>
              <Col span={8}>
                <FormItem label={"Education"}>
                  {getFieldDecorator("education", {
                    initialValue: doctorsDetail.doctor.education
                  })(<Input type="text" name="education" autoComplete="off" />)}
                </FormItem>
              </Col>
              <Col xl={4} lg={5} md={6} sm={8}>
                <FormItem label={"Experience(yrs)"}>
                  {getFieldDecorator("exp", {
                    initialValue: doctorsDetail.doctor.exp
                  })(
                    <NumericInput
                      type="text"
                      name="experience"
                      autoComplete="off"
                    />
                  )}
                </FormItem>
              </Col>
            </Row>

            <Row type="flex" align="middle" gutter={16}>
              <Col lg={4} md={4}>
                <FormItem label={"In clinic fees"}>
                  {getFieldDecorator("fees", {
                    initialValue: doctorsDetail.fees
                  })(
                    <NumericInput type="text" name="fees" autoComplete="off" />
                  )}
                </FormItem>
              </Col>
              <Col xl={4} lg={5} md={8}>
                <FormItem label={"Telemedicine fees"}>
                  {getFieldDecorator("telemedicine_fees", {
                    initialValue: doctorsDetail.telemedicine_fees || null
                  })(<NumericInput autoComplete="off" />)}
                </FormItem>
              </Col>
              <Col lg={4} md={6} sm={6}>
                <FormItem label={"Patients per hour"}>
                  {getFieldDecorator("patients_per_hour", {
                    initialValue: doctorsDetail.doctor.patients_per_hour
                  })(
                    <NumericInput
                      type="text"
                      name="patient_per_hour"
                      autoComplete="off"
                    />
                  )}
                </FormItem>
              </Col>
            </Row>
            <Row type="flex" align="middle" gutter={16}>
              {shwUploadCrt ? (
                <Col sm={12} md={8} lg={8} xl={8}>
                  <FormItem label={"Registration number"}>
                    {getFieldDecorator("reg_nbr", {
                      initialValue: doctorsDetail.doctor.reg_nbr,
                      rules: [
                        {
                          message: "Registration number cant be empty",
                          whitespace: true
                        }
                      ]
                    })(<Input type="text" name="regNo" autoComplete="off" />)}
                  </FormItem>
                </Col>
              ) : (
                <Col span={12}>
                  <FormItem label={"Registration number"}>
                    {getFieldDecorator("reg_nbr", {
                      initialValue: doctorsDetail.doctor.reg_nbr,
                      rules: [
                        {
                          message: "Registration number cant be empty",
                          whitespace: true
                        }
                      ]
                    })(<Input type="text" name="regNo" autoComplete="off" />)}
                  </FormItem>
                </Col>
              )}

              {shwUploadCrt ? (
                <Col sm={12} md={12} l={6} xl={6}>
                  <FormItem
                    label={this.getUploadLabel(regPhotoUrl, showCertificate)}
                  >
                    <Upload
                      showUploadList={false}
                      customRequest={customRequest}
                      onPreview={handlePreview}
                      onChange={handleChange}
                      accept=".jpeg, .jpg, .png, .tiff"
                      disabled={doctorsDetail && doctorsDetail.doctor.verified}
                      multiple={false}
                      className="doc-certificate-upload"
                    >
                      <Spin spinning={uploading}>
                        <Button>
                          <Icon type="upload" /> {"Click to upload"}
                        </Button>
                      </Spin>
                    </Upload>
                  </FormItem>
                </Col>
              ) : (
                ""
              )}
            </Row>
            <Row type="flex" align="middle" gutter={16}>
              <Col lg={4} md={24}>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={updateProcessing}
                >
                  {"Save"}
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    );
  }
}
export default Form.create()(DoctorInfoView);
